<section class="flex flex-col p-5">
	<h4 class="font-bold text-lg">Write a Review</h4>
	<p class="text-xs mb-3">We would love to see our fabric in your creativity!</p>

	<div class="flex justify-start items-center gap-2 w-full rounded bg-[#f7f7f7] border-[1px] border-[#c4c4c4] py-4 px-2 mb-2">

		<img *ngIf="data.productGroup == 'fabric' || data.productGroup == 'swatch'"
			 ngSrc="{{data.customization.fabricProductPreview?.product?.heroImage}}"
			 width="80"
			 height="60"
			 class="rounded"
			 alt="{{data.customization.fabricProductPreview?.product?.name}}"/>

		<img *ngIf="data.productGroup == 'finished'"
			 ngSrc="{{data.customization.finishedProductPreview?.product?.heroImage}}"
			 width="80"
			 height="60"
			 class="rounded"
			 alt="{{data.customization.finishedProductPreview?.product?.name}}"/>

		<div>
			<p class="font-bold capitalize text-sm pb-1" [ngSwitch]="data.productGroup">
				<span *ngIf="'swatch' || 'fabric'">{{ data.customization.fabricProductPreview?.product?.name | titlecase }}</span>
				<span *ngIf="'finished'">{{ data.customization.finishedProductPreview?.product?.name | titlecase }}</span>
			</p>
			<p class="text-xs" *ngIf="data.customization.selectedFabric">
				Fabric: {{ data.customization.selectedFabric.product.name  | titlecase }}
			</p>
			<p class="text-xs" *ngIf="data.customization.selectedSizeOption">
				{{ data.customization.sizeDisplayName }}: {{ data.customization.selectedSizeOption.label  | titlecase }}
			</p>
			<p class="text-xs" *ngIf="data.customization.selectedFinishList?.length">
				{{ data.customization.finishDisplayName }}: {{
					prepareFinishes(data.customization.selectedFinishList) | titlecase
				}}
			</p>
			<p class="text-xs" *ngIf="data.customization.customSize">
				Custom Size: {{ prepareCustomSize(data.customization.customSize) }}
			</p>
		</div>
	</div>

	<form class="flex flex-col w-full">
		<div class="flex items-center gap-2 cursor-pointer mb-2">
			<span *ngFor="let _ of stars; let i = index"
				  (click)="rate(i + 1)"
				  (mouseover)="hoverRating = i + 1"
				  (mouseleave)="hoverRating = 0">
				<span class="star" [class.filled]="(hoverRating || rating) > i">&#9733;</span>
		  	</span>
		</div>
		<div class="flex gap-2 mb-2">
			<input class="ap-review-form-input w-1/2 text-sm"
				   name="city"
				   placeholder="City"
				   [formControl]="city">
			<select class="ap-review-form-input w-1/2 text-sm"
					name="country"
					[formControl]="country">
				<option value="">Country</option>
				<option [value]="country.name" *ngFor="let country of countries">{{ country.name }}</option>
			</select>
		</div>
		<textarea class="ap-review-form-input w-full resize-none mb-2 text-sm"
				  rows="5"
				  placeholder="Share your review here"
				  [formControl]="description"></textarea>
	</form>

	<div class="review-image-upload">
		<div class="flex justify-start items-center gap-2">
			<span class="text-sm">Attach images of our product in use</span>
			<span (click)="fileInput.click()"
				  class="material-symbols-outlined text-[#8d7961] cursor-pointer">add_circle</span>
		</div>
		<input accept="image/jpeg,image/jpg,image/png"
			   (change)="onFileSelected($event)"
			   type="file"
			   #fileInput
			   multiple
			   hidden>
		<div class="flex">
			<ng-container *ngFor="let image of imagePreviews; let i = index">
				<span (click)="onImageClick(i)"
					  class="text-sm mr-2 cursor-pointer hover:font-bold hover:underline">{{ files[i].name }}</span>
			</ng-container>
		</div>
	</div>


	<div class="flex justify-end items-center gap-2">
		<button class="btn border-[#b7a990]"
				mat-dialog-close>Cancel
		</button>
		<button class="btn bg-[#8d7961] text-white border-[#8d7961]"
				(click)="onSubmit()">Submit
		</button>
	</div>
</section>
